import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDU7S-QjZ-O65IYw4f-Mqrm4R3uFwlY4F8",
    authDomain: "nutrimayra-cba6e.firebaseapp.com",
    projectId: "nutrimayra-cba6e",
    storageBucket: "nutrimayra-cba6e.firebasestorage.app",
    messagingSenderId: "280638408677",
    appId: "1:280638408677:web:ba5c18e25e12eb2c5b510c",
    measurementId: "G-GW7X7RSQ6P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

// Initialize Services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export default app;
